<div class="card stop-overflow">
  <div class="card-header">
    <h5 class="card-header-text">
      <i class="icofont icofont-ui-note m-r-10"></i> Discussion Details
    </h5>
  </div>
  <div class="card-body task-details">
    <div class="table-responsive">
      <table class="table table-border table-xs">
        <tbody>
          <tr>
            <td><i class="icofont icofont-user"></i> Created by:</td>

            <td class="float-right">
              <div class="author-profile-bundle">
                <!-- Username -->
                <a
                  class="discussion-author-data"
                  [routerLink]="['/profile', discussion.author.username]"
                >
                  <span class="discussion-meta">
                    {{ discussion.author.username }}
                  </span>
                </a>

                <!-- User image -->
                <a
                  class="discussion-author-data"
                  [routerLink]="['/profile', discussion.author.username]"
                >
                  <img
                    *ngIf="discussion.author.image"
                    class="discussion-preview-user-img"
                    [src]="discussion.author.image"
                    alt="user-profile-img"
                  />
                  <img
                    *ngIf="!discussion.author.image"
                    class="discussion-preview-user-img"
                    [src]="defaultUserImg"
                    alt="user-profile-img"
                  />
                </a>

                <!-- Follow User -->
                <follow-button
                  *ngIf="discussion.author.isFollowing !== null"
                  [hidden]="isUser"
                  class="discussion-author-data"
                  [profile]="discussion.author"
                  (onToggle)="onToggleFollowing($event)"
                >
                </follow-button>
              </div>
            </td>
          </tr>
          <tr>
            <td><i class="icofont icofont-meeting-add"></i> Updated:</td>
            <td class="text-right discussion-meta">
              {{ discussion.updatedAt | date: "longDate":"UTC" }}
            </td>
          </tr>
          <tr>
            <td><i class="icofont icofont-id-card"></i> Created:</td>
            <td class="text-right discussion-meta">
              {{ discussion.createdAt | date: "longDate":"UTC" }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="card-footer">
    <div class="row text-center">
      <div class="col-sm-12">
        <show-voters-button
          [currentUser]="currentUser"
          [discussion]="discussion"
          [limit]="3"
          [config]="{ type: 'upvote' }"
        >
        </show-voters-button>

        <show-voters-button
          [currentUser]="currentUser"
          [discussion]="discussion"
          [limit]="3"
          [config]="{ type: 'downvote' }"
        >
        </show-voters-button>

        <button
          type="button"
          class="
            btn btn-info
            waves-effect waves-light
            btn-sm
            footer-button
            p-l-40 p-r-40
            comment-count-button
          "
        >
          <i class="icofont icofont-speech-comments"></i>
          <span *ngIf="discussion.commentCount > 0">
            {{ discussion.commentCount }} Comments
          </span>
          <span *ngIf="discussion.commentCount < 1">No comments yet</span>
        </button>
      </div>
    </div>
  </div>

  <!-- Content marker -->
  <ng-content></ng-content>
</div>
